import {atom} from "recoil";


const wishListitem = atom({
  key: 'wishListitem',
  default: [],
 });


 export default wishListitem;
